export default {
    // Top-level modal labels
    menuItemLabel: 'Details',
    panelHeading: 'Content details',
    modalDescription: 'Read-only metadata, collaborators, and activity for this content.',

    // Tabs
    tabs: {
        metadata: 'Metadata',
        collaborators: 'Collaborators',
        activity: 'Activity',
    },

    // Empty / loading / error states
    state: {
        loading: 'Loading details…',
        loadError: 'Could not load details.',
        noCollaborators: 'No collaborators added.',
        noActivity: 'No activity recorded yet.',
    },

    // Metadata field labels
    fields: {
        uploader: 'Uploader',
        uploaderEmail: 'Uploader email',
        uploaded: 'Uploaded',
        lastUpdated: 'Last updated',
        device: 'Device',
        fileSize: 'File size',
        duration: 'Duration',
        resolution: 'Resolution',
        mimeType: 'MIME type',
        originalFilename: 'Original filename',
        filestackStatus: 'Filestack status',
    },

    // Inline values
    values: {
        addedAt: 'Added {date}',
        actorSystem: 'System',
        actorUserFallback: 'User #{id}',
    },

    // Activity timeline event labels
    activityType: {
        commentAdded: 'Comment added',
        commentEdited: 'Comment edited',
        commentDeleted: 'Comment deleted',
        comment: 'Comment',
        collaboratorAdded: 'Collaborator added',
        collaboratorRemoved: 'Collaborator removed',
        collaborator: 'Collaborator change',
        editRequested: 'Edit requested',
        editClaimed: 'Edit claimed',
        editDelivered: 'Edit delivered',
        editUpdated: 'Edit updated',
        qcAccepted: 'QC accepted',
        markedCompleted: 'Marked completed',
        contentCompleted: 'Content completed',
        statusChanged: 'Status changed',
        contentUpdated: 'Content updated',
        activity: 'Activity',
    },
}
